import RecipientTypeEnum from '~Api/ApplicationEmail/RecipientTypeEnum';
import { IDictionary } from '~utilities/IDictionary';

const recipientTypeLabels: IDictionary<string> = {
    [RecipientTypeEnum.Cc]: 'CC',
    [RecipientTypeEnum.To]: 'To',
};

export default recipientTypeLabels;
